import script from "./Nostros.vue?vue&type=script&lang=ts&setup=true"
export * from "./Nostros.vue?vue&type=script&lang=ts&setup=true"

import "./Nostros.vue?vue&type=style&index=0&id=21f154c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f154c2"]])

export default __exports__